import { mockCodeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-cite-deep';
const CONV_ID = 'conv-5';
const BADGE_BLOCK_ID = 'blk-cite-badge';
const MD_BLOCK_ID = 'blk-cite-md';
const CITATION_BLOCK_ID = 'blk-cite-citations';
const LINK_BLOCK_ID = 'blk-cite-link';
const DISC_BLOCK_ID = 'blk-cite-disc';
const markdownText = 'Based on **NFPA 25 (2023)** and **NFPA 72 (2022)**, here are the relevant inspection ' +
    'frequency requirements for your sprinkler and fire alarm systems. I found two key sections:';
const agentBadgeBlock = {
    type: 'agent_badge',
    block_id: BADGE_BLOCK_ID,
    block_index: 0,
    agent: mockCodeAgent,
    role_description: 'Searching NFPA standards database'
};
const citationBlock = {
    type: 'citation',
    block_id: CITATION_BLOCK_ID,
    block_index: 2,
    citations: [
        {
            standard: 'NFPA 25',
            edition_year: 2023,
            section: '5.2.1',
            section_title: 'Sprinkler Inspection Frequency',
            content: 'Sprinklers shall be inspected from the floor level annually.',
            content_type: 'requirement',
            obligation: 'shall',
            similarity_score: 0.97
        },
        {
            standard: 'NFPA 72',
            edition_year: 2022,
            section: '14.3.1',
            section_title: 'Fire Alarm Visual Inspection',
            content: 'Fire alarm initiating devices should be visually inspected semiannually.',
            content_type: 'requirement',
            obligation: 'should',
            similarity_score: 0.89
        }
    ]
};
const deepLinkBlock = {
    type: 'deep_link',
    block_id: LINK_BLOCK_ID,
    block_index: 3,
    resource_type: 'inspection',
    resource_id: 'insp-101',
    label: 'View Upcoming Sprinkler Inspection #101',
    url: '/inspections/101',
    icon: 'fa-light fa-clipboard-check'
};
const disclaimerBlock = {
    type: 'disclaimer',
    block_id: DISC_BLOCK_ID,
    block_index: 4,
    text: 'This is an AI-generated summary. Always consult the official NFPA documentation and your local AHJ for compliance.',
    severity: 'legal'
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockCodeAgent),
    makeBlockComplete(agentBadgeBlock, 300),
    makeBlockStart(MD_BLOCK_ID, 1, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText, 20, 40),
    makeBlockEnd(MD_BLOCK_ID),
    makeBlockComplete(citationBlock, 400),
    makeBlockComplete(deepLinkBlock, 200),
    makeBlockComplete(disclaimerBlock, 200),
    makeStreamEnd(RESPONSE_ID, 5, mockCodeAgent)
];
export const scenario = {
    name: 'Fire Code Expert — Citation Deep Dive',
    description: 'NFPA lookup with AgentBadge, streaming markdown, Citation block, DeepLink, and Disclaimer.',
    conversations: mockConversations,
    userMessage: 'What are the inspection frequencies for sprinklers and fire alarms?',
    agentIdentity: mockCodeAgent,
    sseSequence
};
